<template>
  <InfoCard
    class="education-info"
    icon="iconfont iconEducation"
    :title="$t(`${i18nPrefix}.title.education`)"
    :infoList="educationList"
    :infoLines="infoLines"
  ></InfoCard>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import InfoCard from '@/components/candidate/infoCard.vue'
import { addI18nProperty, getConstantI18nValue } from '@/i18n'
import { DEGREE } from '@/constant/meta'

export default {
  components: {
    InfoCard
  },
  props: {
    educations: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      i18nPrefix: 'personal.profile'
    }
  },
  computed: {
    infoLines () {
      const i18nPrefix = this.i18nPrefix
      const lines = {
        institution: {
          labelI18nKey: `${i18nPrefix}.label.school`,
          dataKey: 'schoolI18nName'
        },
        degreeAndMajor: {
          labelI18nKey: `${i18nPrefix}.label.degreeAndMajor`,
          formatter: (val, info) => {
            const degree = info.degree_level ? getConstantI18nValue(DEGREE, info.degree_level, 'meta.DEGREE') : ''
            return _.filter([degree, info.majorI18nName]).join(', ')
          }
        },
        date: {
          labelI18nKey: `${i18nPrefix}.label.date`,
          formatter: (val, info) => {
            const starDate = info.start_date ? moment(info.start_date).format('MM/YYYY') : ''
            const endDate = info.end_date ? moment(info.end_date).format('MM/YYYY') : this.$t(`${i18nPrefix}.label.now`)
            return _.filter([starDate, endDate]).join(' - ')
          }
        }
      }
      return lines
    },
    educationList () {
      return _.map(this.educations, item => {
        addI18nProperty(item, 'schoolI18nName', 'cn_name', 'name', item.school)
        addI18nProperty(item, 'majorI18nName', 'cn_name', 'name', item.major)
        return item
      })
    }
  },
  created () {

  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.education-info {
  ::v-deep {
    .card-title-container {
      .title-icon {
        font-size: 26px;
      }

      .title {
        color: #303133;
        font-weight: 500;
      }
    }
  }

  .card-list {
    .info-line-list {
      .info-line {
        .info-label {
          font-weight: 500;
        }
      }
    }

    .info-card {
        padding-left: 20px;
        padding-right: 20px;
      }
  }
}
</style>
